import { Component, Host, h, Prop } from '@stencil/core';
import store from '../../../../global/store';

@Component({
  tag: 'ui-bank-search-bank-overlay',
  styleUrl: 'ui-bank-search-bank-overlay.scss',
  shadow: false,
})
export class UiBankSearchBankOverlay {
  @Prop() hasForm = false;

  render() {
    return (
      <Host
        class={{
          'has-form': this.hasForm,
          hidden: !store.state.isOverlayVisible,
        }}
        role="dialog"
        aria-modal="true"
      >
        <div class="wrapper">
          {store.state.selectedBank && (
            <ui-bank-search-bank-overlay-details
              has-form={this.hasForm}
            ></ui-bank-search-bank-overlay-details>
          )}
          {this.hasForm && (
            <ui-bank-search-webform>
              <slot />
            </ui-bank-search-webform>
          )}
        </div>
      </Host>
    );
  }
}
